import { FC } from 'react';

import { ColorSegmentsIcon } from './ColorSegmentsIcon';

interface Props {
    readonly iconKey: string;
    readonly className?: string;
}

const COLOR_VALUES: Record<string, string> = {
    red: '#ef3340',
    green: '#20ad68',
    blue: '#2d8de0',
    purple: '#8659df',
    black: '#24262b',
    yellow: '#ffca3a',
};

const PREFIX = 'one_piece_color_';

const colorsFor = (iconKey: string): string[] =>
    iconKey
        .slice(PREFIX.length)
        .split('_')
        .map((color) => COLOR_VALUES[color])
        .filter(Boolean);

export const OnePieceColorIcon: FC<Props> = ({ iconKey, className }) => (
    <ColorSegmentsIcon colors={colorsFor(iconKey)} className={className} />
);
